import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loader from '../Loader';
import MailShareDialog from './MailShareDialog';
import Dialog from '@material-ui/core/Dialog';
import { cloneDeep } from 'lodash';
import { IconButton } from '@projeccions-pdc/react-icon';
import FileDeliveryService from '../../../apiclients/FileDeliveryService';
import FileService from '../../../apiclients/FileService';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import AppContext from '../../../AppContext';
import CustomMailShareDialog from '../../KerryLogistics/CustomMailShareDialog';
import LocalizedStrings from '../../Localization/localization';

const styles = (theme) => ({
    root: {
        zIndex: '1401!important',
    },
});

class FileShareButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attachments: [], //this.prepareAttachments(cloneDeep(this.props.attachments)),
            allAttachmentsFilled: false,
            open: false,
            loading: false,
        };
    }

    componentDidMount() {
        if (this.props.autoMode === true) {
            this.handleClickOpen();
        } else {
            this.prepareState();
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        // moved to click event!
        // if (!this.areArraysEqual(this.props.attachments, prevProps.attachments)) {
        //     this.prepareState();
        // }
    };

    setStateAsync = (state) => new Promise((resolve) => this.setState(state, resolve));

    prepareState = async () => {
        // console.log(this.props.attachments);
        let attachments = await this.prepareAttachments(cloneDeep(this.props.attachments));
        let showShareable = false;
        if (this.props.attachments.length > 0) {
            if (attachments.length > 1 && this.props.currentFileId) {
                let currentFile = attachments.filter((att) => {
                    return att.identifier === this.props.currentFileId;
                });
                if (currentFile.length > 0) {
                    currentFile = currentFile[0];
                    showShareable = currentFile.shareable;
                }
            } else {
                showShareable = attachments[0].shareable;
            }
        }
        // console.log(attachments, showShareable);
        await this.setStateAsync({ attachments, showShareable });
        return attachments;
    };

    prepareAttachments = async (attachments) => {
        for (let i = 0; i < attachments.length; i++) {
            try {
                let response;
                if (attachments[i].urlModifier === 'get-content') {
                    response = await FileDeliveryService.getContent(attachments[i].identifier, undefined, undefined, true);
                } else {
                    response = await FileDeliveryService.getFile(attachments[i].identifier, true);
                }

                let shareable = 'no';
                if (response.headers) {
                    let pragma = response.headers.get('pragma');
                    if (pragma) {
                        shareable = pragma.split(':')[1];
                    }
                }
                if (shareable === 'yes') {
                    shareable = true;
                } else {
                    shareable = false;
                }
                // console.log('shareable', shareable)
                attachments[i].shareable = shareable;
            } catch (err) {
                console.log(err);
            }
        }
        return attachments;
    };

    areArraysEqual = (arrayA, arrayB) => {
        if ((arrayA === undefined && arrayB !== undefined) || (arrayA !== undefined && arrayB === undefined)) return false;
        if (arrayA.length !== arrayB.length) return false;
        for (let a = 0; a < arrayA.length; a++) {
            let found = false;
            for (let b = 0; b < arrayB.length && found === false; b++) {
                if (arrayA[a].identifier === arrayB[b].identifier) {
                    found = true;
                }
            }
            if (found === false) {
                return false;
            }
        }
        return true;
    };

    handleClickOpen = async () => {
        await this.setStateAsync({ allAttachmentsFilled: false, open: true });
        const attachments = await this.prepareState();
        this.getShareFilesURL(attachments);
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleError = (err) => {
        console.log(err);
    };

    handleSuccess = () => {
        this.setState({ open: false });
    };

    getShareFilesURL = (attachments = this.state.attachments) => {
        this.setState({ loading: true });
        let getShareURLOps = [];

        // let appContext = new AppContext();
        // let platformConfig = appContext.getPlatformConfig();

        // let tempInDays = platformConfig.shareExpireInDays ? platformConfig.shareExpireInDays : 30;
        // let now = new Date();
        // let expireDate = now.setDate(now.getDate() + tempInDays);

        attachments.forEach((attachment) => {
            if (attachment.shareable === true) {
                if (!attachment.url || !attachment.name) {
                    getShareURLOps.push(
                        FileService.shareFile(attachment.identifier).then((res) => {
                            return {
                                url: res.url,
                                name: res.filename,
                                shareToken: res.shareToken,
                                identifier: 'file~' + attachment.identifier,
                                resourceSubtype: attachment.resourceSubtype,
                                shareable: attachment.shareable,
                                // icon: attachment.icon,
                                // isImage: attachment.isImage
                            };
                        })
                    );
                } else {
                    getShareURLOps.push(
                        Promise.resolve({
                            url: attachment.url,
                            name: attachment.name,
                            identifier: attachment.identifier,
                            resourceSubtype: attachment.resourceSubtype,
                            shareable: attachment.shareable,
                            // icon: attachment.icon,
                            // isImage: attachment.isImage
                        })
                    );
                }
            }
        });

        if (getShareURLOps.length > 0) {
            Promise.all(getShareURLOps)
                .then((attachments) => {
                    this.setState({ attachments, loading: false, allAttachmentsFilled: true });
                })
                .catch(() => {
                    this.setState({ loading: false, allAttachmentsFilled: false });
                    this.props.notify('error', LocalizedStrings.errorFetchAttachents);
                });
        } else {
            this.setState({ loading: false, allAttachmentsFilled: false });
        }
        //[{ name: '', url: '', identifier: '', icon?: '', isImage?:true|false }]
    };

    render() {
        let appContext = new AppContext();
        return (
            <div style={this.props.style}>
                {this.state.showShareable === true && this.props.autoMode !== true ? (
                    this.state.loading ? (
                        <Loader loading={true} primaryColor={'rgb(92,92,92)'} size={'20px'} />
                    ) : this.props.buttonComponent !== undefined ? (
                        <div style={{ display: 'inline-block' }} onClick={this.handleClickOpen}>
                            {this.props.buttonComponent}
                        </div>
                    ) : (
                        <IconButton
                            name="md-share"
                            primaryColor={this.props.buttonPrimaryColor ? this.props.buttonPrimaryColor : 'rgb(92,92,92)'}
                            secondaryColor={this.props.buttonSecondaryColor ? this.props.buttonSecondaryColor : 'rgb(23,92,191)'}
                            onClick={this.handleClickOpen}
                            size={this.props.buttonSize ? this.props.buttonSize : '20px'}
                        />
                    )
                ) : (
                    ''
                )}

                <Dialog
                    fullScreen={this.props.autoMode === true ? true : this.props.fullScreen}
                    open={this.state.open && this.state.allAttachmentsFilled}
                    onClose={this.props.autoMode === true ? undefined : this.handleClose}
                    classes={{
                        root: this.props.classes.root,
                    }}
                >
                    {/* FIXME: customization for kerry demo */}
                    {appContext.getPlatformId() === 'kerrylogistics' ? (
                        <CustomMailShareDialog
                            attachments={this.state.attachments}
                            notify={this.props.notify}
                            onError={this.handleError}
                            onSuccess={this.handleSuccess}
                            onClose={this.handleClose}
                        />
                    ) : (
                        <MailShareDialog
                            attachments={this.state.attachments}
                            notify={this.props.notify}
                            onError={this.handleError}
                            onSuccess={this.handleSuccess}
                            onClose={this.handleClose}
                            autoMode={this.props.autoMode}
                        />
                    )}
                </Dialog>
            </div>
        );
    }
}

FileShareButton.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
    attachments: PropTypes.array.isRequired, //[{ name: '', url: '', identifier: '', icon?: '', isImage?:true|false }]
    notify: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    buttonPrimaryColor: PropTypes.string,
    buttonSecondaryColor: PropTypes.string,
    buttonSize: PropTypes.string,
    style: PropTypes.object,
    currentFileId: PropTypes.string,
    buttonComponent: PropTypes.any,
    autoMode: PropTypes.bool,
};

export default withStyles(styles)(withMobileDialog()(FileShareButton));
